/**
 * @generated SignedSource<<804d46e8712aa55e37a775ac80ee5df9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type queueFragment_ScheduleDeleteMutation$variables = {
  scheduleId: number;
};
export type queueFragment_ScheduleDeleteMutation$data = {
  readonly jobScheduleDelete: {
    readonly deleted: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type queueFragment_ScheduleDeleteMutation = {
  response: queueFragment_ScheduleDeleteMutation$data;
  variables: queueFragment_ScheduleDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scheduleId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "scheduleId",
    "variableName": "scheduleId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queueFragment_ScheduleDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobScheduleDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "jobScheduleDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queueFragment_ScheduleDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobScheduleDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "jobScheduleDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "705b4a97bb31dc8c832939f107d398d9",
    "id": null,
    "metadata": {},
    "name": "queueFragment_ScheduleDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation queueFragment_ScheduleDeleteMutation(\n  $scheduleId: Int!\n) {\n  jobScheduleDelete(scheduleId: $scheduleId) {\n    deleted\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9722500079f08e5104d204c6d6214993";

export default node;
